<template lang="pug">
.v-breadcrumbs.breadcrumbs(v-if="breadcrumbsData")
	.breadcrumbs__container.container
		.breadcrumbs__list(v-if="breadcrumbsData.items" :class="breadcrumbsData.className")
			template(v-for="(item, i) in breadcrumbsData.items" :key="i")
				template(v-if="i === breadcrumbsData.items.length - 1")
					.breadcrumbs__item {{item.text}}
						v-svg-icon.breadcrumbs__separator(icon="separator")
				template(v-else)
					a.breadcrumbs__item(:href="item.link" :target="getLinkTarget(item.link)") {{item.text}}
						v-svg-icon.breadcrumbs__separator(icon="separator")
</template>

<script>

import sourceMixin from '../components/mixins/v-mixin-source.vue';
import linkTargetMixin from '../components/mixins/v-mixin-link-target.vue';

export default {
	mixins: [
		sourceMixin,
		linkTargetMixin
	],

	data() {
		return {
			breadcrumbsData: null
		};
	},

	methods: {
		dataSet(data) {
			this.breadcrumbsData = data;
		}
	}
}
</script>